import React, { useState, useEffect, Fragment } from "react";
import LeadDetailsApt from "components/sales/formSection/leadDetails/leadDetailsApt";
import PocDetails from "components/sales/formSection/pocDetails/pocDetails";
import Location from "components/sales/formSection/location/location";
import CategoryDetails from "components/sales/formSection/categoryDetails/categoryDetails";
import GatesForm from "components/sales/formSection/gates/addgateCreateLead";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import Notfound from "pages/notfound";

const EditApartments = ({
  locationCity,
  cities,
  locationZone,
  zones,
  locationArea,
  areas,
  locationType,
  locTypesData,
  locationState,
  locationPinCode,
  pincodeData,
  rwaTenureFun,
  rwaTenureData,
  appartmentDropDown,
  getApartmentDropDown,
  getCurrentLocation,
  latlng,
  toastMsg,
  editApartmentLeadSubmit,
  getDetails,
  match,
  viewDetails,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [corporateLeadData, setCorporateLeadData] = useState(null);
  const [corporatePocDetails, setCorporatePocDetails] = useState(null);
  const [corporateLocation, setCorporateLocation] = useState(null);
  const [gateDetails, setGateDetails] = useState(null);
  const [corporateCategoryDetails, setCorporateCategoryDetails] = useState(
    null
  );
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);

  useEffect(() => {
    if (match?.params?.id !== undefined && match?.params?.id !== null) {
      (async () => {
        const leadTypeId =
          (await JSON.parse(localStorage.getItem("viewDetail"))) &&
          JSON.parse(localStorage.getItem("viewDetail"))[0].lead_type_id;
        const requestData = {
          lead_id: match.params.id,
          lead_type: leadTypeId,
        };
        if (requestData) {
          const res = await getDetails(requestData);
          if (res === null || res === "") {
            setIsRender(true);
          }
        }
      })();
    }
  }, [getDetails]);

  const handleLeadSubmit = (val) => {
    setCorporateLeadData(val);
  };
  const handlePocSubmit = (val) => setCorporatePocDetails(val);
  const handleLocSubmit = (val) => setCorporateLocation(val);
  const handleCatSubmit = (val) => setCorporateCategoryDetails(val);
  const handleGatesSubmit = (val) => setGateDetails(val);

  const handleModalHide = () => setIsModal(false);

  const handleSubmit = (leadId) => {
    const editCorporate = {
      ...corporateLeadData,
      ...corporatePocDetails,
      ...corporateLocation,
      ...corporateCategoryDetails,
      ...gateDetails
    };
    if (
      corporateLeadData === null ||
      corporatePocDetails === null ||
      corporateLocation === null ||
      corporateCategoryDetails === null 
      // || gateDetails === null
    ) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      (async () => {
        const res = await editApartmentLeadSubmit({
          ...editCorporate,
          leadId: leadId,
        });
        if (res) {
          setIsModal(true);
        }
      })();
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getApartmentDropDown();
      setTimeout(() => setIsLoading(false), 500);
    })();
  }, [getApartmentDropDown]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={() => handleSubmit(match?.params?.id)}
          className="btn btn-primary"
        >
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };

  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={localization.categoryLead}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isLoading={isLoading}
      isGoback
    >
      <LeadDetailsApt
        inputLabel={localization.clientAprtname}
        handleValue={handleLeadSubmit}
        isApartment={true}
        appartmentDropDown={appartmentDropDown}
        prefilledData={viewDetails}
      />
      <PocDetails
        handleValue={handlePocSubmit}
        appartmentDropDown={appartmentDropDown}
        prefilledData={viewDetails}
      />
      <Location
        locationCity={locationCity}
        cities={cities}
        locationZone={locationZone}
        zones={zones}
        locationArea={locationArea}
        areas={areas}
        locationType={locationType}
        locTypesData={locTypesData}
        handleValue={handleLocSubmit}
        locationState={locationState}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        getCurrentLocation={getCurrentLocation}
        latlng={latlng}
        toastMsg={toastMsg}
        prefilledData={viewDetails}
      />
      <CategoryDetails
        isApartments={true}
        handleValue={handleCatSubmit}
        rwaTenureFun={rwaTenureFun}
        rwaTenureData={rwaTenureData}
        appartmentDropDown={appartmentDropDown}
        prefilledData={viewDetails}
      />
      {/* <GatesForm
        gateType={rwaTenureData.gateType}
        handleValue={handleGatesSubmit}
        prefilledData={viewDetails}
      /> */}

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.updateLeadSuccess}</h5>
          <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.preSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-transparent"
          >
            {localization.updateLead}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
    </Layout>
  );
};

export default EditApartments;
